import React from 'react';

// Components
import { Grid, Tooltip } from '@mui/material';
import { SelectInput } from '../../SelectInput';
import { SelectAll } from '../../SelectAll';

// Styles
import { AddCircleOutlineRounded, Delete } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

// Icons
import { StyledTable, StyledTh, StyledTd } from './styles';
import { CustomButtonV2, CustomIconButtonDemo } from '../../../pages/styles';

// Utils
import { ColorsContext } from '../../../Context/ColorsContext';
import { useTranslation } from 'react-i18next'
import { AttachmentTechnicalSupervisors } from '../../AttachmentTechnicalSupervisors';
import { Auth } from "../../../utils/auth";

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../Context/PermissionsContext';

export const ContractWorkersAssign = ({
    data,
    users,
    plantList,
    handleChange,
    clickAdd,
    clickRemove,
    loading,
    titleWorker = '',
    isTechnicalSupervisor = false,
    handleFilesDrop,
    deleteAttach,
    downloadFile,
    isAdmin = false,
}) => {

    const theme = useTheme();
    const { t } = useTranslation();
    const { colors } = React.useContext(ColorsContext);
    const ability = useAbility(AbilityContext);

    const [user, setUser] = React.useState(null);
    const { getUser } = new Auth();

    function returnSelectedData(arraySelected, list) {
		// Logic for MUI Autocomplete component bug
		// Data of autocomplete multiple must be taken directly from options array
        let setlData = []
        if (!list) return []
            arraySelected?.map((el) => {
                let objData = list?.filter((obj) => obj.id === el.id)
                setlData.push(...objData)
            })
        return setlData
    }

    function checkDisabled(row, disabledForce = false) {
        if (!isTechnicalSupervisor) return false

        // Si puede crear contratos y no puede subir adjuntos, entonces puede modificar supervisores
        if (ability.can("CreateContract") && !ability.can("UploadAttachmentSupervisor")) return false || disabledForce

        if ((row?.username?.toString().toLowerCase() === user.username?.toString().toLowerCase()) && !disabledForce) return true
        else if (row?.username?.toString().toLowerCase() !== user.username?.toString().toLowerCase()) return true
    }

    function onFilesDrop(newFile, idx) {
        handleFilesDrop(newFile, idx)
    }

    function onFilesDelete(file, supIdx) {
        deleteAttach(file, supIdx)
    }

    React.useEffect(() => {
        if (user === null) {
          setUser(getUser());
        }
    }, [user, getUser]);

    return (
        <>
            <StyledTable>
                <thead>
                    <tr>
                        <StyledTh style={{ width: '20%' }}>{titleWorker || t('contract.table.contractor')}</StyledTh>
                        <StyledTh>{t('contract.table.scope')}</StyledTh>
                        {isTechnicalSupervisor && <StyledTh>{t('contract.table.attachments')}</StyledTh>}
                        <StyledTh style={{ width: '80px', textAlign: 'center' }}>{t('common.actions.delete')}</StyledTh>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={`contractor-${index}`}>
                            <StyledTd>
                                <SelectInput
                                    placeholder={titleWorker || t('contract.table.contractor')}
                                    onChange={(value) => handleChange('contractors', value, index)}
                                    value={row}
                                    options={users}
                                    keyValue="contractor"
                                    sx={{ width: '100%' }}
                                    error={row.errorEmptyContractors}
                                    disabled={loading || checkDisabled(row)}
                                />
                            </StyledTd>
                            <StyledTd>
                                <SelectAll
                                    onChange={(value) => handleChange('plants', value, index)}
                                    value={returnSelectedData(row.plants, plantList)}
                                    options={plantList || []}
                                    keyValue="name"
                                    sx={{ width: '100%' }}
                                    multiple={true}
                                    hasError={!(!row.hasEmptyPlants)}
                                    messageError={row.errorEmptyPlants}
                                    disabled={loading || checkDisabled(row)}
                                    limitTags={1}
                                />
                            </StyledTd>
                            {isTechnicalSupervisor && (
                                <StyledTd>
                                    <AttachmentTechnicalSupervisors
                                        files={row?.supervisorAttachments || []}
                                        disabled={isAdmin ? false : checkDisabled(row, true)}
                                        onFilesDrop={(e) => onFilesDrop(e, index)}
                                        deleteAttach={(e) => onFilesDelete(e, index)}
                                        downloadFile={downloadFile}
                                    />
                                </StyledTd>
                            )}
                            <StyledTd style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                <Tooltip title={t('contract.remove')}>
                                    <span>
                                        <CustomIconButtonDemo
                                            size="small"
                                            btnType="delete"
                                            onClick={() => clickRemove(index)}
                                            disabled={loading || checkDisabled(row)}
                                        >
                                            <Delete fontSize='34px' />
                                        </CustomIconButtonDemo>
                                    </span>
                                </Tooltip>
                            </StyledTd>
                        </tr>
                    ))}
                </tbody>
            </StyledTable>

            {/* Si puede crear contrato y no puede subir archivo, entonces puede agregar los supervisores */}
            {((isTechnicalSupervisor && ability.can("CreateContract") && !ability.can("UploadAttachmentSupervisor")) || (!isTechnicalSupervisor && ability.can("UpdateContractor"))) &&
                <Grid container mt={2}>
                    <CustomButtonV2
                        btnType="primary"
                        sx={{ width: '140px' }}
                        onClick={clickAdd}
                        disabled={loading}
                        startIcon={<AddCircleOutlineRounded />}
                    >
                        {t('contract.addAnother')}
                    </CustomButtonV2>
                </Grid>
            }
        </>
    )
}